/**
 * TreeSwitcherIcon  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { Icon, ICON_SIZE } from "../Icon";
import { ITreeBaseNodeProps } from "./TreeBase";

export interface ITreeSwitcherIconProps extends ITreeBaseNodeProps {
	size?: ICON_SIZE;
}

export const TreeSwitcherIcon: React.FC<ITreeSwitcherIconProps> = ({ isLeaf, size }) =>
	isLeaf ? null : <Icon name="mdi/menu-down" size={size} />;

TreeSwitcherIcon.defaultProps = {
	size: ICON_SIZE.SMALL
};
